// Action types for flowchart blocks Redux state management
export const SET_FLOWCHART_BLOCKS = 'SET_FLOWCHART_BLOCKS';
export const CLEAR_FLOWCHART_BLOCKS = 'CLEAR_FLOWCHART_BLOCKS';
